import React from 'react'
import Field from '../Field'
import stripCurrencyFormat from '../../utils/formatters/stripCurrencyFormat'
import formatCurrency from '../../utils/formatters/formatCurrency'

const formatValue = (value) => value == null ? '' : formatCurrency(value)
const parseValue = (value) => {
  const newValue = value == null ? null : stripCurrencyFormat(value)
  return newValue == null || newValue === '' ? null : newValue
}

function CurrencyField({ ...inputProps }) {
  return (
    <Field
      format={formatValue}
      parse={parseValue}
      {...inputProps}
    />
  )
}

export default CurrencyField



// WEBPACK FOOTER //
// ./src/components/CurrencyField/index.js